import type { InputSearchSort } from "@nosto/nosto-js/client"
import createMapper from "../createMapper"

/**
 * Encodes the query object by converting the `sort` property of the `products` object to an object with key-value pairs.
 * @example
 * products.sort.0.field=price&products.sort.0.order=desc to products.sort=price~asc
 * customUrlMappings: [
 *    compressSortParameters
 * ]
 *
 * @hidden
 */
export default createMapper<{ sort?: InputSearchSort[] }, { sort?: string }>({
    encode({ sort, ...rest }) {
        if (!sort) return rest
        const compressed = sort.map(({ field, order }) => `${field}~${order}`).join(",")
        return { ...rest, sort: compressed }
    },
    decode({ sort, ...rest }) {
        if (!sort) return rest
        if (typeof sort === "object") {
            const expanded = Object.entries(sort).map(([field, order]) => ({
                field,
                order
            }))
            return { ...rest, sort: expanded }
        }
        const expanded = sort
            .split(",")
            .filter(Boolean)
            .map(s => s.split("~"))
            .map(([field, order]) => ({ field, order }))
        return { ...rest, sort: expanded }
    }
})
